import React from 'react';

function HistoryList({ history, onCopy }) {
  if (!history || history.length === 0) return null;

  return (
    <section className="history">
      <div className="history__header">
        <h2 className="history__title">История приглашений</h2>
        <span className="history__badge">{history.length}</span>
      </div>
      <div className="history__card">
        <table className="history__table">
          <thead>
            <tr>
              <th className="history__th">Конференция</th>
              <th className="history__th">Ссылка</th>
              <th className="history__th history__th--actions">Действие</th>
            </tr>
          </thead>
          <tbody>
            {history.map(({ room, link }) => (
              <tr key={link} className="history__row">
                <td className="history__cell history__cell--room">{room}</td>
                <td className="history__cell history__cell--link">
                  <a
                    className="history__link"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link}
                  </a>
                </td>
                <td className="history__cell history__cell--actions">
                  <button
                    type="button"
                    className="btn btn--small"
                    onClick={() => onCopy(link)}
                  >
                    Копировать
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default HistoryList;
